import { calendarAvailabilityConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";


// create interview
export const create_calendar_availability_action =
  (data) => async (dispatch) => {
    dispatch({
      type: calendarAvailabilityConstants.CREATE_CALENDAR_AVAILABILITY_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.common.calendarAvailability,
        data
      );
      if (response.status) {
        dispatch({
          type: calendarAvailabilityConstants.CREATE_CALENDAR_AVAILABILITY_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarAvailabilityConstants.CREATE_CALENDAR_AVAILABILITY_ACTION_FAILURE,
        payload: e.msg,
      });

    }
  };

// update interview
export const update_calendar_availability_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: calendarAvailabilityConstants.UPDATE_CALENDAR_AVAILABILITY_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.common.calendarAvailabilityById.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: calendarAvailabilityConstants.UPDATE_CALENDAR_AVAILABILITY_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarAvailabilityConstants.UPDATE_CALENDAR_AVAILABILITY_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

//delete event
export const delete_calendar_availability_action =
  (id) => async (dispatch) => {
    dispatch({
      type: calendarAvailabilityConstants.DELETE_CALENDAR_AVAILABILITY_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        config.common.calendarAvailabilityById.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: calendarAvailabilityConstants.DELETE_CALENDAR_AVAILABILITY_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarAvailabilityConstants.DELETE_CALENDAR_AVAILABILITY_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

//get event details
export const get_calendar_availability_details_action =
  (id) => async (dispatch) => {
    dispatch({
      type: calendarAvailabilityConstants.GET_CALENDAR_AVAILABILITY_DETAILS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.common.calendarAvailabilityById.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: calendarAvailabilityConstants.GET_CALENDAR_AVAILABILITY_DETAILS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarAvailabilityConstants.GET_CALENDAR_AVAILABILITY_DETAILS_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

//get event lists
export const get_calendar_availability_lists_action =
  () => async (dispatch) => {
    dispatch({
      type: calendarAvailabilityConstants.GET_CALENDAR_AVAILABILITY_LISTS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.common.calendarAvailabilityLists
      );
      if (response.status) {
        dispatch({
          type: calendarAvailabilityConstants.GET_CALENDAR_AVAILABILITY_LISTS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarAvailabilityConstants.GET_CALENDAR_AVAILABILITY_LISTS_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };
